import { PAGE_HEADING_BOTTOM_MARGIN } from "@packages/design-system/constants";
import { cn } from "@packages/lib/utils";
import React from "react";

interface PageHeadingProps {
  title: string;
  subtitle?: string;
  background?: "tertiary" | "default";
  overline?: string;
}

// Design from https://tailwindui.com/components/marketing/sections/header#component-fed988a810519f7aefef13224b3a814d
const PageHeading: React.FC<PageHeadingProps> = ({
  title,
  subtitle,
  background,
  overline,
}) => {
  return (
    <div
      className={`border-border-light border-b-2 pt-12 pb-9 sm:pt-16 sm:pb-12 ${PAGE_HEADING_BOTTOM_MARGIN}`}
    >
      <div className="max-w-4xl">
        {overline && (
          <div
            className={cn(
              "text-muted-foreground mb-2 text-base font-semibold tracking-widest uppercase",
            )}
          >
            {overline}
          </div>
        )}
        <h1
          className={cn(
            "text-heading text-5xl font-semibold tracking-tight text-pretty sm:text-6xl",
            background === "tertiary"
              ? "text-tertiary-foreground"
              : "text-heading",
          )}
        >
          {title}
        </h1>
        {subtitle &&
          (typeof subtitle === "string" && subtitle.match(/[\r\n]/) ? (
            <div>
              {subtitle.split(/\r?\n\r?\n/).map((para, idx) => (
                <p
                  key={`subtitle-para-${idx}`}
                  className={cn(
                    "mt-2 text-lg/8 font-medium",
                    background === "tertiary"
                      ? "text-muted-foreground"
                      : "text-muted-heading",
                  )}
                >
                  {para}
                </p>
              ))}
            </div>
          ) : (
            <p
              className={cn(
                "mt-2 text-lg/8 font-medium",
                background === "tertiary"
                  ? "text-muted-foreground"
                  : "text-muted-heading",
              )}
            >
              {subtitle}
            </p>
          ))}
      </div>
    </div>
  );
};

export default PageHeading;
